import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { sipHistoryDetailsApi } from "../../redux/features/sip/sipHistoryDetailsSlice";
import {
  Box,
  Button,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import {
  cancelSipApi,
  sipReset,
} from "../../redux/features/sip/cancelSipSlice";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: "1rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

export default function SipHistoryDetails() {
  const { sipId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [selectedValue, setSelectedValue] = useState("");

  // console.log("LOCATION============", location.state);

  const { metalType } = location.state;

  const sipDetails = useSelector(
    (state) => state.sipHistoryDetailsSlice.data.data
  );

  const { umn, recurringAmount, status, expiryDate, firstChargeDate } =
    sipDetails?.subscription || "";
  useEffect(() => {
    dispatch(sipHistoryDetailsApi(sipId));
  }, [sipId, dispatch]);

  const handleCancelSip = () => {
    dispatch(cancelSipApi(sipId));
  };

  const cancelSip = useSelector((state) => state.cancelSipSlice.data);

  useEffect(() => {
    if (cancelSip.error === false) {
      dispatch(sipReset());
      navigate("/dashboard/profile/sip-history");
      toast.success("SIP Cancelled Successfully");
    }
  }, [cancelSip, dispatch]);
  return (
    <div className="invoice_container">
      {/* HEADER======== */}
      <div
        className="universal_card"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <div>
          <img
            src={
              metalType === "gold"
                ? "/images/gold_sip.png"
                : "/images/silver_sip.png"
            }
            alt="gold"
            width={60}
          />
        </div>
        <h5>AUGMONT</h5>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "18px",
            fontWeight: "bold",
            color: status === "ACTIVE" ? "green" : "red",
          }}
        >
          {status}
        </div>
      </div>
      {/* DETAILS===== */}
      <div className="universal_card">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            <div style={{ textWrap: "nowrap" }}>SIP Amount</div>
            <div>Frequency</div>
            <div>Start Date</div>
            <div>End Date</div>
            <div>UMN</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div>₹{recurringAmount}</div>
            <div>Monthly</div>
            <div>{firstChargeDate}</div>
            <div>
              {expiryDate ? expiryDate.split(" ")[0] : "N/A"}
            </div>
            <div style={{ wordBreak: "break-all" }}>{umn}</div>
          </div>
        </div>
        {/* CANCEL BTN====  */}
        {status === "ACTIVE" && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
            }}
          >
            <CustomButton label="CANCEL SIP" onClick={handleOpen} />
          </div>
        )}

        {/* MODAL======  */}
        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <p
                style={{
                  backgroundColor: "#F3F2EE",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                Deleting your Digital Gold SIP will stop your Digital Gold
                Saving for your future. Sta Saved for the long to meet your
                financial goals.
              </p>

              <div>
                <Typography
                  id="modal-modal-description"
                  sx={{
                    mt: 2,
                    textAlign: "center",
                    fontWeight: "bold",
                    color: "#510d10",
                  }}
                >
                  May we know the reason?
                </Typography>

                <RadioGroup
                  // sx={{ padding: "1rem" }}
                  name="sip_options"
                  value={selectedValue}
                  onChange={(e) => setSelectedValue(e.target.value)}
                >
                  <FormControlLabel
                    value="no_money"
                    control={
                      <Radio
                        sx={{
                          color: "#510d10",
                          "&.Mui-checked": {
                            color: "#510d10",
                          },
                        }}
                      />
                    }
                    label="I do not have the money to continue this SIP"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="new_sip"
                    control={
                      <Radio
                        sx={{
                          color: "#510d10",
                          "&.Mui-checked": {
                            color: "#510d10",
                          },
                        }}
                      />
                    }
                    label="I want to start a new Gold SIP on Batuk App"
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="save_elsewhere"
                    control={
                      <Radio
                        sx={{
                          color: "#510d10",
                          "&.Mui-checked": {
                            color: "#510d10",
                          },
                        }}
                      />
                    }
                    label="I have decided to save elsewhere."
                    labelPlacement="end"
                  />
                  <FormControlLabel
                    value="goal_completed"
                    control={
                      <Radio
                        sx={{
                          color: "#510d10",
                          "&.Mui-checked": {
                            color: "#510d10",
                          },
                        }}
                      />
                    }
                    label="I completed my savings goal."
                    labelPlacement="end"
                  />
                </RadioGroup>
              </div>
              <p
                style={{
                  backgroundColor: "#F3F2EE",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                <strong>Note:</strong> Once the SIP is deleted, all future
                debits for this SIP will be stopped. SIP debit requests already
                in progress and sent to your bank will be deducted even after
                deletion.
              </p>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CustomButton
                  label="Cancel SIP"
                  onClick={handleCancelSip}
                  outLined={true}
                />
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
}
